import { fabric } from "fabric";
export class StraightConnectorLine {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 4;
    this.startX = options.startX;
    this.startY = options.startY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the straight path (Make it non-movable)
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth || 3,
      fill: "transparent",
      selectable: true, // Can be selected to change stroke width
      evented: true, // Allow events on path
      hasControls: false, // No controls on the path itself
      lockMovementX: true, // Prevent moving on X
      lockMovementY: true, // Prevent moving on Y
      class: "line",
    });

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY,true);
    this.endNode = this._createControlNode(this.endX, this.endY,false);
    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    // Bind movement events
    this._bindEvents();
  }

  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

// When deselecting start or end node, check control point visibility
this.startNode.on("deselected", () => {
  this._checkControlPointVisibility();
});

this.endNode.on("deselected", () => {
  this._checkControlPointVisibility();
});

  }

 // Function to show control points
 _showControlPoints() {
  this.startNode.set({ visible: true });
  this.endNode.set({ visible: true });
  this.canvas.renderAll();
}

// Function to hide control points
_hideControlPoints() {
  this.startNode.set({ visible: false });
  this.endNode.set({ visible: false });
  this.canvas.renderAll();
}

// Ensure control points visibility based on line selection
_checkControlPointVisibility() {
  console.log("this.path.selected",this.path )
  if (this.path.selected) {
    this._showControlPoints();
  } else {
    this._hideControlPoints();
  }
}

  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);

    // Create updated path for the straight line
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });

    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);

      // Compute the direction vector
      const dx = this.endX - this.startX;
      const dy = this.endY - this.startY;
      const length = Math.sqrt(dx * dx + dy * dy);
  
      if (length === 0) return; // Avoid division by zero
  
      // Normalize the direction vector
      const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);
  
    // Update control points
    this.startNode.set({
      left: this.startX - this.startNode.radius - offsetX,
      top: this.startY - this.startNode.radius - offsetY,
    });

    this.endNode.set({
      left: this.endX - this.endNode.radius + offsetX,
      top: this.endY - this.endNode.radius + offsetY,
    });

    // Ensure Fabric updates positions correctly
    this.startNode.setCoords();
    this.endNode.setCoords();

    // Re-render the canvas
    this.canvas.renderAll();
  }

  _createPathString() {
    // Create path string for a line without an arrow
    return `M ${this.startX} ${this.startY} L ${this.endX} ${this.endY}`;
  }

  _createControlNode(x, y,isStartNode=true) {
      // Compute the direction vector
      const dx = this.endX - this.startX;
      const dy = this.endY - this.startY;
      const length = Math.sqrt(dx * dx + dy * dy);
  
      if (length === 0) return; // Avoid division by zero
  
      // Normalize the direction vector
      const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);
  
      // Adjust position based on whether it's the start or end node
      const adjustedX = isStartNode ? x - offsetX : x + offsetX;
      const adjustedY = isStartNode ? y - offsetY : y + offsetY;
    return new fabric.Circle({
      left:adjustedX- 5, // Adjust for radius of circle
      top: adjustedY - 5,  // Adjust for radius of circle
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class: "line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}


export class ArrowConnectorLine {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 4;
    this.arrowSize = options.arrowSize || 10;
    this.startX = options.startX;
    this.startY = options.startY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the straight path (Make it non-movable)
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth || 3,
      fill: "transparent",
      selectable: true, // Can be selected to change stroke width
      evented: true, // Allow events on path
      hasControls: false, // No controls on the path itself
      lockMovementX: true, // Prevent moving on X
      lockMovementY: true, // Prevent moving on Y
      class: "line",
    });

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY,true);
    this.endNode = this._createControlNode(this.endX, this.endY,false);
    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    console.log(" this.path", this.path)
    // Bind events
    this._bindEvents();

  }

  // This method updates the line based on the current positions of the startNode and endNode
  _updateLine() {
    this._updatePath(); // This will recreate the path based on the updated coordinates
  }

  _updateControlPoints() {
    this.startNode.setCoords();
    this.endNode.setCoords();
    this.canvas.renderAll();
  }
  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

  // When deselecting start or end node, check control point visibility
  this.startNode.on("deselected", () => {
    this._checkControlPointVisibility();
  });

  this.endNode.on("deselected", () => {
    this._checkControlPointVisibility();
  });
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }
  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);

    // Create updated path for the straight line
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });

    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);

      // Compute the direction vector
      const dx = this.endX - this.startX;
      const dy = this.endY - this.startY;
      const length = Math.sqrt(dx * dx + dy * dy);
  
      if (length === 0) return; // Avoid division by zero
  
      // Normalize the direction vector
      const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);
  
    // Update control points
    this.startNode.set({
      left: this.startX - this.startNode.radius - offsetX,
      top: this.startY - this.startNode.radius - offsetY,
    });

    this.endNode.set({
      left: this.endX - this.endNode.radius + offsetX,
      top: this.endY - this.endNode.radius + offsetY,
    });

    // Ensure Fabric updates positions correctly
    this.startNode.setCoords();
    this.endNode.setCoords();

    // Re-render the canvas
    this.canvas.renderAll();
  }

  _createPathString() {
    return `M ${this.startX} ${this.startY} L ${this.endX} ${this.endY} ${this._createArrowPath(this.endX, this.endY)}`;
  }

  _createArrowPath(x, y) {
    const arrowSize = this.arrowSize;
    const angle = Math.atan2(this.startY - this.endY, this.startX - this.endX) * 180 / Math.PI;

    const arrowTipX = x;
    const arrowTipY = y;
    const arrowX1 = x + arrowSize * Math.cos((angle - 45) * Math.PI / 180);
    const arrowY1 = y + arrowSize * Math.sin((angle - 45) * Math.PI / 180);
    const arrowX2 = x + arrowSize * Math.cos((angle + 45) * Math.PI / 180);
    const arrowY2 = y + arrowSize * Math.sin((angle + 45) * Math.PI / 180);

    return `M ${arrowTipX} ${arrowTipY} L ${arrowX1} ${arrowY1} L ${arrowX2} ${arrowY2} Z`;
  }

  _createControlNode(x, y,isStartNode= true) {
      // Compute the direction vector
      const dx = this.endX - this.startX;
      const dy = this.endY - this.startY;
      const length = Math.sqrt(dx * dx + dy * dy);
  
      if (length === 0) return; // Avoid division by zero
  
      // Normalize the direction vector
      const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);
  
      // Adjust position based on whether it's the start or end node
      const adjustedX = isStartNode ? x - offsetX : x + offsetX;
      const adjustedY = isStartNode ? y - offsetY : y + offsetY;
    return new fabric.Circle({
      left: adjustedX-5,// Adjust for radius of circle
      top: adjustedY -5,  // Adjust for radius of circle
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class: "line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
      lineId: this.id
    });
  }

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}

export class DoubleArrowConnectorLine {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 4;
    this.arrowSize = options.arrowSize || 10;
    this.startX = options.startX;
    this.startY = options.startY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the straight path (Make it non-movable)
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth || 3,
      fill: "transparent",
      selectable: true, // Can be selected to change stroke width
      evented: true, // Allow events on path
      hasControls: false, // No controls on the path itself
      lockMovementX: true, // Prevent moving on X
      lockMovementY: true, // Prevent moving on Y
      class: "line",
    });

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY,true);
    this.endNode = this._createControlNode(this.endX, this.endY,false);

    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    console.log(" this.path", this.path)
    // Bind events
    this._bindEvents();

  }

  // This method updates the line based on the current positions of the startNode and endNode
  _updateLine() {
    this._updatePath(); // This will recreate the path based on the updated coordinates
  }

  _updateControlPoints() {
    this.startNode.setCoords();
    this.endNode.setCoords();
    this.canvas.renderAll();
  }
  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

// When deselecting start or end node, check control point visibility
this.startNode.on("deselected", () => {
  this._checkControlPointVisibility();
});

this.endNode.on("deselected", () => {
  this._checkControlPointVisibility();
});
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }
  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);

    // Create updated path for the straight line
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });

    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);

      // Compute the direction vector
      const dx = this.endX - this.startX;
      const dy = this.endY - this.startY;
      const length = Math.sqrt(dx * dx + dy * dy);
  
      if (length === 0) return; // Avoid division by zero
  
      // Normalize the direction vector
      const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);
  
    // Update control points
    this.startNode.set({
      left: this.startX - this.startNode.radius - offsetX,
      top: this.startY - this.startNode.radius - offsetY,
    });

    this.endNode.set({
      left: this.endX - this.endNode.radius + offsetX,
      top: this.endY - this.endNode.radius + offsetY,
    });

    // Ensure Fabric updates positions correctly
    this.startNode.setCoords();
    this.endNode.setCoords();

    // Re-render the canvas
    this.canvas.renderAll();
  }

  _createPathString() {
    return `M ${this.startX} ${this.startY} ${this._createArrowPath(this.startX, this.startY, true)} 
            L ${this.endX} ${this.endY} ${this._createArrowPath(this.endX, this.endY, false)}`;
}
_createArrowPath(x, y, isStartArrow = false) {
  const arrowSize = this.arrowSize;
  
  // Calculate angle based on direction
  let angle;
  if (isStartArrow) {
      angle = Math.atan2(this.endY - this.startY, this.endX - this.startX) * 180 / Math.PI;
  } else {
      angle = Math.atan2(this.startY - this.endY, this.startX - this.endX) * 180 / Math.PI;
  }

  // Arrow tip coordinates
  const arrowTipX = x;
  const arrowTipY = y;

  // Compute the left and right points of the arrowhead
  const arrowX1 = x + arrowSize * Math.cos((angle - 45) * Math.PI / 180);
  const arrowY1 = y + arrowSize * Math.sin((angle - 45) * Math.PI / 180);
  const arrowX2 = x + arrowSize * Math.cos((angle + 45) * Math.PI / 180);
  const arrowY2 = y + arrowSize * Math.sin((angle + 45) * Math.PI / 180);

  return `M ${arrowTipX} ${arrowTipY} L ${arrowX1} ${arrowY1} L ${arrowX2} ${arrowY2} Z`;
}

  _createControlNode(x, y,isStartNode= true) {
      // Compute the direction vector
      const dx = this.endX - this.startX;
      const dy = this.endY - this.startY;
      const length = Math.sqrt(dx * dx + dy * dy);
  
      if (length === 0) return; // Avoid division by zero
  
      // Normalize the direction vector
      const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);
  
      // Adjust position based on whether it's the start or end node
      const adjustedX = isStartNode ? x - offsetX : x + offsetX;
      const adjustedY = isStartNode ? y - offsetY : y + offsetY;
    return new fabric.Circle({
      left: adjustedX-5,// Adjust for radius of circle
      top: adjustedY -5,  // Adjust for radius of circle
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class: "line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
      lineId: this.id
    });
  }

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}


export class CurvedPathConnector {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 3;
    this.startX = options.startX;
    this.startY = options.startY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the curved path (Make it non-movable)
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth,
      fill: "transparent",
      selectable: true, // Can be selected to change stroke width
      evented: true, // Allow events on path
      hasControls: false, // No controls on the path itself
      lockMovementX: true, // Prevent moving on X
      lockMovementY: true, // Prevent moving on Y
      class: "line",
    });

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY,true);
    this.endNode = this._createControlNode(this.endX, this.endY,false);

    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    // Bind movement events
    this._bindEvents();

    // Bind stroke width change
    this._bindStrokeWidthChange();
  }

  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

    // When deselecting start or end node, check control point visibility
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }

  // Prevent moving the line but allow stroke width change
  _bindStrokeWidthChange() {
    this.path.on("selected", () => {
      console.log("Path selected! You can change the stroke width.");
    });

    this.startNode.on("selected", () => {
      console.log("Start node selected!");
    });

    this.endNode.on("selected", () => {
      console.log("End node selected!");
    });
  }

  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);
  
    // Create updated path
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth:this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });
  
    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);
  
    // Calculate offset for control points
    const offsetDistance = 3; // Distance to keep points away from the line
    const startOffsetX = (this.endX - this.startX) > 0 ? -offsetDistance : offsetDistance;
    const startOffsetY = (this.endY - this.startY) > 0 ? -offsetDistance : offsetDistance;
  
    const endOffsetX = (this.endX - this.startX) > 0 ? offsetDistance : -offsetDistance;
    const endOffsetY = (this.endY - this.startY) > 0 ? offsetDistance : -offsetDistance;
  
    // Update control points with offset
    this.startNode.set({
      left: this.startX - this.startNode.radius + startOffsetX,
      top: this.startY - this.startNode.radius + startOffsetY,
    });
  
    this.endNode.set({
      left: this.endX - this.endNode.radius + endOffsetX,
      top: this.endY - this.endNode.radius + endOffsetY,
    });
  
    // Ensure Fabric updates positions correctly
    this.startNode.setCoords();
    this.endNode.setCoords();
  
    // Re-render the canvas
    this.canvas.renderAll();
  }
  
  _createPathString() {
    const controlPoint1X = (this.startX + this.endX) / 2;
    const controlPoint1Y = this.startY;
    const controlPoint2X = (this.startX + this.endX) / 2;
    const controlPoint2Y = this.endY;

    return `M ${this.startX} ${this.startY} 
            C ${controlPoint1X} ${controlPoint1Y}, ${controlPoint2X} ${controlPoint2Y}, ${this.endX} ${this.endY}`;
  }

  _createControlNode(x, y,isStartNode= true) {

    // Compute the direction vector
    const dx = this.endX - this.startX;
    const dy = this.endY - this.startY;
    const length = Math.sqrt(dx * dx + dy * dy);

    if (length === 0) return; // Avoid division by zero

    // Normalize the direction vector
    const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
    const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);

    // Adjust position based on whether it's the start or end node
    const adjustedX = isStartNode ? x - offsetX : x + offsetX;
    const adjustedY = isStartNode ? y - offsetY : y + offsetY;    
    return new fabric.Circle({
      left: adjustedX-5,
      top: adjustedY -5,
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class:"line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }
  
  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}

export class CurvedArrowConnector {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 3;
    this.arrowSize = options.arrowSize || 10;
    this.startX = options.startX;
    this.startY = options.startY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the curved path (Make it non-movable)
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth,
      fill: "transparent",
      selectable: true, // Can be selected to change stroke width
      evented: true, // Allow events on path
      hasControls: false, // No controls on the path itself
      lockMovementX: true, // Prevent moving on X
      lockMovementY: true, // Prevent moving on Y
      class: "line",
    });

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY,true);
    this.endNode = this._createControlNode(this.endX, this.endY,false);

    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    // Bind movement events
    this._bindEvents();

    // Bind stroke width change
    this._bindStrokeWidthChange();
  }

  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

// When deselecting start or end node, check control point visibility
this.startNode.on("deselected", () => {
  this._checkControlPointVisibility();
});

this.endNode.on("deselected", () => {
  this._checkControlPointVisibility();
});
this.canvas.on('object:moving', function (e) {
  console.log("control pointv ",e.target.type ,e.target, e.target.connectedLine,e.target.connectedArrow)
  if (e.target.type === 'controlPoint') {
      const line = e.target.connectedLine;
      const arrow = e.target.connectedArrow;
      this.updateArrow(line, arrow);
  }
});
  }

  updateArrow(line, arrow) {
    const points = line.get('points');
    const x1 = points[0], y1 = points[1]; // Start point
    const x2 = points[2], y2 = points[3]; // End point

    // Calculate the angle of the line
    let angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);

    // 🛑 FLIP the arrow direction if line is reversed
    if (Math.abs(angle) > 90) {
        angle += 180; // Flip the arrowhead
    }

    // Adjust arrowhead position
    const arrowSize = 10; // Distance to keep arrow outside line
    const offsetX = arrowSize * Math.cos(angle * (Math.PI / 180));
    const offsetY = arrowSize * Math.sin(angle * (Math.PI / 180));

    console.log("angle",angle)
    arrow.set({
        left: x2 - offsetX,
        top: y2 - offsetY,
        angle: angle, // 🔄 Auto flip arrowhead
    });

    line.setCoords();
    arrow.setCoords();
    this.canvas.renderAll();
}

  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }
  // Prevent moving the line but allow stroke width change
  _bindStrokeWidthChange() {
    this.path.on("selected", () => {
      console.log("Path selected! You can change the stroke width.");
    });

    this.startNode.on("selected", () => {
      console.log("Start node selected!");
    });

    this.endNode.on("selected", () => {
      console.log("End node selected!");
    });
  }

  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);
  
    // Create updated path
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth:this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });
  
    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);
  
    // Compute the direction vector
    const dx = this.endX - this.startX;
    const dy = this.endY - this.startY;
    
    const length = Math.sqrt(dx * dx + dy * dy);
    const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
      const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);
  
    // Update control points with offset
    this.startNode.set({
      left: this.startX - this.startNode.radius - offsetX,
      top: this.startY - this.startNode.radius - offsetY,
    });
  
    this.endNode.set({
      left: this.endX - this.endNode.radius + offsetX,
      top: this.endY - this.endNode.radius + offsetY,
    });
  
    // Ensure Fabric updates positions correctly
    this.startNode.setCoords();
    this.endNode.setCoords();
  
    // Re-render the canvas
    this.canvas.renderAll();
  }
  
  
  _createPathString() {
    const controlPoint1X = (this.startX + this.endX) / 2;
    const controlPoint1Y = this.startY;
    const controlPoint2X = (this.startX + this.endX) / 2;
    const controlPoint2Y = this.endY;
    const endArrowPath = this._createArrowPath(this.endX, this.endY);

    return `M ${this.startX} ${this.startY} 
            C ${controlPoint1X} ${controlPoint1Y}, ${controlPoint2X} ${controlPoint2Y}, ${this.endX} ${this.endY} 
            ${endArrowPath}`;
  }

  _createArrowPath(x, y) {
    const arrowSize = this.arrowSize;
    const arrowTipX = x;
    const arrowX1 = x - arrowSize / 2;
    const arrowY1 = y - arrowSize / 2;
    const arrowX2 = x - arrowSize / 2;
    const arrowY2 = y + arrowSize / 2;

    return `M ${arrowTipX} ${y} L ${arrowX1} ${arrowY1} L ${arrowX2} ${arrowY2} Z`;
  }

  _createControlNode(x, y,isStartNode=true) {
     // Compute the direction vector
     const dx = this.endX - this.startX;
     const dy = this.endY - this.startY;
     const length = Math.sqrt(dx * dx + dy * dy);
 
     if (length === 0) return; // Avoid division by zero
 
     // Normalize the direction vector
     const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
     const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);
 
     // Adjust position based on whether it's the start or end node
     const adjustedX = isStartNode ? x - offsetX : x + offsetX;
     const adjustedY = isStartNode ? y - offsetY : y + offsetY;

    return new fabric.Circle({
      left: adjustedX- 5, // Apply X offset
      top: adjustedY - 5 ,  // Apply Y offset
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class:"line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }
  
  

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}
export class CurvedDoubleArrowConnector {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 3;
    this.arrowSize = options.arrowSize || 10;
    this.startX = options.startX;
    this.startY = options.startY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the curved path (Make it non-movable)
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth,
      fill: "transparent",
      selectable: true, // Can be selected to change stroke width
      evented: true, // Allow events on path
      hasControls: false, // No controls on the path itself
      lockMovementX: true, // Prevent moving on X
      lockMovementY: true, // Prevent moving on Y
      class: "line",
    });

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY, true);
    this.endNode = this._createControlNode(this.endX, this.endY, false);

    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    // Bind movement events
    this._bindEvents();

    // Bind stroke width change
    this._bindStrokeWidthChange();
  }

  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

    // When deselecting start or end node, check control point visibility
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }

  // Prevent moving the line but allow stroke width change
  _bindStrokeWidthChange() {
    this.path.on("selected", () => {
      console.log("Path selected! You can change the stroke width.");
    });

    this.startNode.on("selected", () => {
      console.log("Start node selected!");
    });

    this.endNode.on("selected", () => {
      console.log("End node selected!");
    });
  }

  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);
  
    // Create updated path
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });
  
    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);
  
    // Calculate offset for control points
    const offsetDistance = 2; // Distance to keep points 2px away from the arrows
    const startOffsetX = (this.endX - this.startX) > 0 ? -offsetDistance : offsetDistance;
    const startOffsetY = (this.endY - this.startY) > 0 ? -offsetDistance : offsetDistance;
  
    const endOffsetX = (this.endX - this.startX) > 0 ? offsetDistance : -offsetDistance;
    const endOffsetY = (this.endY - this.startY) > 0 ? offsetDistance : -offsetDistance;
  
    // Update control points with offset
    this.startNode.set({
      left: this.startX - this.startNode.radius + startOffsetX,
      top: this.startY - this.startNode.radius + startOffsetY,
    });
  
    this.endNode.set({
      left: this.endX - this.endNode.radius + endOffsetX,
      top: this.endY - this.endNode.radius + endOffsetY,
    });
  
    // Ensure Fabric updates positions correctly
    this.startNode.setCoords();
    this.endNode.setCoords();
  
    // Re-render the canvas
    this.canvas.renderAll();
  }
  
  _createPathString() {
    const controlPoint1X = (this.startX + this.endX) / 2;
    const controlPoint1Y = this.startY;
    const controlPoint2X = (this.startX + this.endX) / 2;
    const controlPoint2Y = this.endY;
    const startArrowPath = this._createArrowPath(this.startX, this.startY, true);
    const endArrowPath = this._createArrowPath(this.endX, this.endY, false);

    return `M ${this.startX} ${this.startY} 
            C ${controlPoint1X} ${controlPoint1Y}, ${controlPoint2X} ${controlPoint2Y}, ${this.endX} ${this.endY} 
            ${startArrowPath} ${endArrowPath}`;
  }

  _createArrowPath(x, y, isStart) {
    const arrowSize = this.arrowSize;
    const arrowTipX = x;
    const arrowX1 = x + (isStart ? arrowSize / 2 : -arrowSize / 2);
    const arrowY1 = y - arrowSize / 2;
    const arrowX2 = x + (isStart ? arrowSize / 2 : -arrowSize / 2);
    const arrowY2 = y + arrowSize / 2;

    return `M ${arrowTipX} ${y} L ${arrowX1} ${arrowY1} L ${arrowX2} ${arrowY2} Z`;
  }

  _createControlNode(x, y,isStartNode= true ) {
   // Compute the direction vector
   const dx = this.endX - this.startX;
   const dy = this.endY - this.startY;
   const length = Math.sqrt(dx * dx + dy * dy);

   if (length === 0) return; // Avoid division by zero

   // Normalize the direction vector
   const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
   const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);

   // Adjust position based on whether it's the start or end node
   const adjustedX = isStartNode ? x - offsetX : x + offsetX;
   const adjustedY = isStartNode ? y - offsetY : y + offsetY;
    return new fabric.Circle({
      left: adjustedX - 5, // Apply X offset
      top: adjustedY - 5,  // Apply Y offset
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class:"line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}


export class ElbowConnectorLine {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 3;
    this.arrowSize = options.arrowSize || 10;

    this.startX = options.startX;
    this.startY = options.startY;
    this.elbowX = options.elbowX;
    this.elbowY = options.elbowY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the elbow path without arrow
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false, // No controls on the path
      lockMovementX: true, // Prevent movement on X
      lockMovementY: true, // Prevent movement on Y
      class: "line",
    });

    // Create control points (start, elbow, end)
    this.startNode = this._createControlNode(this.startX, this.startY,true);
    this.elbowNode = this._createControlNode(this.elbowX, this.elbowY,false);
    this.endNode = this._createControlNode(this.endX, this.endY,false);

    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    // Bind movement events
    this._bindEvents();

    // Bind stroke width change
    this._bindStrokeWidthChange();
  }

  // _bindEvents() {
  //   // When start node moves, update path
  //   this.startNode.on("moving", () => {
  //     this.startX = this.startNode.left + this.startNode.radius;
  //     this.startY = this.startNode.top + this.startNode.radius;
  //     this._updatePath();
  //   });

  //   // When elbow node moves, update path
  //   this.elbowNode.on("moving", () => {
  //     this.elbowX = this.elbowNode.left + this.elbowNode.radius;
  //     this.elbowY = this.elbowNode.top + this.elbowNode.radius;
  //     this._updatePath();
  //   });

  //   // When end node moves, update path
  //   this.endNode.on("moving", () => {
  //     this.endX = this.endNode.left + this.endNode.radius;
  //     this.endY = this.endNode.top + this.endNode.radius;
  //     this._updatePath();
  //   });
  // }

  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

    // When deselecting start or end node, check control point visibility
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }
  _bindStrokeWidthChange() {
    // Handle stroke width change on select
    this.path.on("selected", () => {
      console.log("Path selected! You can change the stroke width.");
    });
  }

  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);

    // Dynamically recalculate the elbow position based on start and end points
    const middleX = (this.startX + this.endX) / 2; // Calculate a mid-point for the elbow
    const middleY = (this.startY + this.endY) / 2;

    // Update the elbow position
    this.elbowX = middleX;  // You can adjust this logic based on your specific needs
    this.elbowY = middleY;  // You can adjust this logic based on your specific needs

    // Create updated path
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });

    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);

        // Compute the direction vector
        const dx = this.endX - this.startX;
        const dy = this.endY - this.startY;
        const length = Math.sqrt(dx * dx + dy * dy);
    
        if (length === 0) return; // Avoid division by zero
    
        // Normalize the direction vector
        const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
        const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);
    
      // Update control points
      this.startNode.set({
        left: this.startX - this.startNode.radius - offsetX,
        top: this.startY - this.startNode.radius - offsetY,
      });
  
      this.endNode.set({
        left: this.endX - this.endNode.radius + offsetX,
        top: this.endY - this.endNode.radius + offsetY,
      });
  
    // Ensure positions are updated correctly
    this.startNode.setCoords();
    this.elbowNode.setCoords();
    this.endNode.setCoords();

    // Re-render canvas
    this.canvas.renderAll();
  }

  _createPathString() {
    // Create path string with elbow but no arrow at the end
    return `M ${this.startX} ${this.startY} 
            L ${this.elbowX} ${this.startY} 
            L ${this.elbowX} ${this.endY} 
            L ${this.endX} ${this.endY}`;
  }

  _createControlNode(x, y ,isStartNode=true) {
     // Compute the direction vector
     const dx = this.endX - this.startX;
     const dy = this.endY - this.startY;
     const length = Math.sqrt(dx * dx + dy * dy);
 
     if (length === 0) return; // Avoid division by zero
 
     // Normalize the direction vector
     const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
     const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);
 
     // Adjust position based on whether it's the start or end node
     const adjustedX = isStartNode ? x - offsetX : x + offsetX;
     const adjustedY = isStartNode ? y - offsetY : y + offsetY;
    return new fabric.Circle({
      left: adjustedX - 5,
      top: adjustedY - 5,
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class: "line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}

export class ElbowConnectorLineWithArrow {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 3;
    this.arrowSize = options.arrowSize || 10;

    this.startX = options.startX;
    this.startY = options.startY;
    this.elbowX = options.elbowX;
    this.elbowY = options.elbowY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the elbow path with arrow
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false, // No controls on the path
      lockMovementX: true, // Prevent movement on X
      lockMovementY: true, // Prevent movement on Y
      class: "line",
    });

    // Create control points (start, elbow, end)
    this.startNode = this._createControlNode(this.startX, this.startY, true );
    this.elbowNode = this._createControlNode(this.elbowX, this.elbowY,false);
    this.endNode = this._createControlNode(this.endX, this.endY, false);

    // Add elements to canvas
    this.canvas.add(this.path, this.startNode, this.endNode);

    // Bind movement events
    this._bindEvents();

    // Bind stroke width change
    this._bindStrokeWidthChange();
  }

  // _bindEvents() {
  //   // When start node moves, update path
  //   this.startNode.on("moving", () => {
  //     this.startX = this.startNode.left + this.startNode.radius;
  //     this.startY = this.startNode.top + this.startNode.radius;
  //     this._updatePath();
  //   });

  //   // When elbow node moves, update path
  //   this.elbowNode.on("moving", () => {
  //     this.elbowX = this.elbowNode.left + this.elbowNode.radius;
  //     this.elbowY = this.elbowNode.top + this.elbowNode.radius;
  //     this._updatePath();
  //   });

  //   // When end node moves, update path
  //   this.endNode.on("moving", () => {
  //     this.endX = this.endNode.left + this.endNode.radius;
  //     this.endY = this.endNode.top + this.endNode.radius;
  //     this._updatePath();
  //   });
  // }
  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

  // When deselecting start or end node, check control point visibility
  this.startNode.on("deselected", () => {
    this._checkControlPointVisibility();
  });

  this.endNode.on("deselected", () => {
    this._checkControlPointVisibility();
  });
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }
  _bindStrokeWidthChange() {
    // Handle stroke width change on select
    this.path.on("selected", () => {
      console.log("Path selected! You can change the stroke width.");
    });
  }

  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);

    // Dynamically recalculate the elbow position based on start and end points
    const middleX = (this.startX + this.endX) / 2; // Calculate a mid-point for the elbow
    const middleY = (this.startY + this.endY) / 2;

    // Update the elbow position
    this.elbowX = middleX;  // You can adjust this logic based on your specific needs
    this.elbowY = middleY;  // You can adjust this logic based on your specific needs

    // Create updated path
    this.path = new fabric.Path(this._createPathString(), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });

    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);

    // Compute the direction vector
    const dx = this.endX - this.startX;
    const dy = this.endY - this.startY;
    const length = Math.sqrt(dx * dx + dy * dy);

    if (length === 0) return; // Avoid division by zero

    // Normalize the direction vector
    const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
    const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);

    // Update control points
    this.startNode.set({
    left: this.startX - this.startNode.radius - offsetX,
    top: this.startY - this.startNode.radius - offsetY,
    });

    this.endNode.set({
    left: this.endX - this.endNode.radius + offsetX,
    top: this.endY - this.endNode.radius + offsetY,
    });
    // Ensure positions are updated correctly
    this.startNode.setCoords();
    this.elbowNode.setCoords();
    this.endNode.setCoords();

    // Re-render canvas
    this.canvas.renderAll();
  }

  _createPathString() {
    // Create path string with elbow and arrow
    const arrowPath = this._createArrowPath(this.endX, this.endY);
    return `M ${this.startX} ${this.startY} 
            L ${this.elbowX} ${this.startY} 
            L ${this.elbowX} ${this.endY} 
            L ${this.endX} ${this.endY} 
            ${arrowPath}`;
  }

  _createArrowPath(x, y) {
    const arrowSize = this.arrowSize;
    const arrowX1 = x - arrowSize;
    const arrowY1 = y - arrowSize / 2;
    const arrowX2 = x - arrowSize;
    const arrowY2 = y + arrowSize / 2;

    return `M ${x} ${y} L ${arrowX1} ${arrowY1} L ${arrowX2} ${arrowY2} Z`;
  }

  _createControlNode(x, y,isStartNode=true) {
    // Compute the direction vector
    const dx = this.endX - this.startX;
    const dy = this.endY - this.startY;
    const length = Math.sqrt(dx * dx + dy * dy);

    if (length === 0) return; // Avoid division by zero

    // Normalize the direction vector
    const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
    const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);

    // Adjust position based on whether it's the start or end node
    const adjustedX = isStartNode ? x - offsetX : x + offsetX;
    const adjustedY = isStartNode ? y - offsetY : y + offsetY;
    return new fabric.Circle({
      left:adjustedX - 5,
      top: adjustedY - 5,
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      class: "line",
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }

  // Change stroke width of the path
  setStrokeWidth(newWidth) {
    this.strokeWidth = newWidth;
    this._updatePath();
  }
}

export class ElbowConnectorLineWithDoubleArrow {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.strokeWidth = options.strokeWidth || 4;
    this.arrowSize = options.arrowSize || 10; // Default arrow size
    this.offsetDistance = 3; // Distance to keep points away from the arrows

    this.startX = options.startX;
    this.startY = options.startY;
    this.elbowX = options.elbowX;
    this.elbowY = options.elbowY;
    this.endX = options.endX;
    this.endY = options.endY;

    // Create the path for the elbow connector with integrated arrows
    this.path = this._createElbowPath(
      this.startX,
      this.startY,
      this.elbowX,
      this.elbowY,
      this.endX,
      this.endY
    );

    if (this.path instanceof fabric.Object) {
      this.canvas.add(this.path);
    } else {
      console.error("Error: Path is not a valid Fabric.js object.");
    }

    // Create control points
    this.startNode = this._createControlNode(this.startX, this.startY, true);
    this.elbowNode = this._createControlNode(this.elbowX, this.elbowY ,false);
    this.endNode = this._createControlNode(this.endX, this.endY, false);

    // Add control points to canvas
    this.canvas.add(this.startNode,this.endNode);

    // Bind movement events
    this._bindEvents();
  }

  _createElbowPath(startX, startY, elbowX, elbowY, endX, endY) {
    // Create the path for the elbow connector with arrows at both ends
    const pathData = this._createPathString(startX, startY, elbowX, elbowY, endX, endY);
    return new fabric.Path(pathData, {
      stroke: "black",
      strokeWidth: this.strokeWidth,
      fill: "transparent",
      class: "line",
      objectCaching: false,
      selectable: true,
      hasControls: false, // No controls on the path
      lockMovementX: true, // Prevent movement on X
      lockMovementY: true, // Prevent movement on Y
      evented: true,
    });
  }

  _createPathString(startX, startY, elbowX, elbowY, endX, endY) {
    // Create path string with elbow and two arrows integrated into it
    const startArrowPath = this._createArrowPath(startX, startY, true);  // Left arrow at the start
    const endArrowPath = this._createArrowPath(endX, endY, false);    // Right arrow at the end
    return `M ${startX} ${startY} 
            L ${elbowX} ${startY} 
            L ${elbowX} ${endY} 
            L ${endX} ${endY} 
            ${startArrowPath} ${endArrowPath}`;
  }

  _createArrowPath(x, y, isStart) {
    // Arrow direction is determined by isStart: true for left, false for right
    const arrowAngle = isStart ? 180 : 0; // Left arrow for start (180 degrees), Right arrow for end (0 degrees)
    const arrowSize = this.arrowSize;

    // Calculate the coordinates for the arrowhead
    const arrowX1 = x + (isStart ? arrowSize : -arrowSize);
    const arrowY1 = y - arrowSize / 2;
    const arrowX2 = x + (isStart ? arrowSize : -arrowSize);
    const arrowY2 = y + arrowSize / 2;

    // Return the path for the arrowhead with a solid fill color
    return `M ${x} ${y} L ${arrowX1} ${arrowY1} L ${arrowX2} ${arrowY2} Z`;
  }

  _createControlNode(x, y, isStartNode= true) {
   // Compute the direction vector
   const dx = this.endX - this.startX;
   const dy = this.endY - this.startY;
   const length = Math.sqrt(dx * dx + dy * dy);

   if (length === 0) return; // Avoid division by zero

   // Normalize the direction vector
   const offsetX = (dx / length) * (this.strokeWidth / 2 + 2);
   const offsetY = (dy / length) * (this.strokeWidth / 2 + 2);

   // Adjust position based on whether it's the start or end node
   const adjustedX = isStartNode ? x - offsetX : x + offsetX;
   const adjustedY = isStartNode ? y - offsetY : y + offsetY;

    return new fabric.Circle({
      left: adjustedX - 5,
      top:adjustedY - 5,
      radius: 5,
      fill: "red",
      stroke: "black",
      strokeWidth: 2,
      hasControls: false,
      hasBorders: false,
      selectable: true,
      evented: true,
    });
  }

  _bindEvents() {
    // When start node moves, update line
    this.startNode.on("moving", () => {
      this.startX = this.startNode.left + this.startNode.radius;
      this.startY = this.startNode.top + this.startNode.radius;
      this._updatePath();
      this._showControlPoints();
       });
  
    // When end node moves, update line
    this.endNode.on("moving", () => {
      this.endX = this.endNode.left + this.endNode.radius;
      this.endY = this.endNode.top + this.endNode.radius;
      this._updatePath();
      this._showControlPoints();
     });
  
    // When selecting the line, ensure control points show up
    this.path.on("selected", () => {
      this._showControlPoints(); // Show control points when line is selected
    });
  
    // When deselecting the line, hide the control points
    this.path.on("deselected", () => {
      this._hideControlPoints(); // Hide control points when line is deselected
    });
    
    this.startNode.on("selected", () => {
      this._showControlPoints();
    });
  
    this.endNode.on("selected", () => {
      this._showControlPoints();
    });

    // Handle clicking anywhere on canvas
    this.canvas.on("selection:cleared", () => {
      this._hideControlPoints();
    });
  
     // Fix: Ensure clicking on the path itself always shows control points
  this.canvas.on("mouse:down", (e) => {
    if (e.target === this.path) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  });
    // When deselecting the start or end node, hide the control points
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  
    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

  // Keep control points visible if the path was last selected but deselected by clicking on canvas
  this.canvas.on("selection:cleared", () => {
    // Ensure control points remain visible if the path was the last moved object
    if (this.lastSelectedPath) {
      this._showControlPoints();
    }
  });

  setTimeout(() => {
    this.canvas.setActiveObject(this.path); // Select path manually
    this.canvas.discardActiveObject(); // Then deselect it
    this._hideControlPoints(); // Hide control points after deselection
    this.canvas.renderAll();
  }, 100); // Small delay to allow Fabric.js to process object addition

    // When deselecting start or end node, check control point visibility
    this.startNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });

    this.endNode.on("deselected", () => {
      this._checkControlPointVisibility();
    });
  // Track the last selected path to maintain control point visibility
  // this.canvas.on("selection:created", (e) => {
  //   if (e.selected && e.selected.includes(this.path)) {
  //     this.lastSelectedPath = this.path;
  //   } else {
  //     this.lastSelectedPath = null;
  //   }
  // });
  }
  
  // Function to show control points
  _showControlPoints() {
    this.startNode.set({ visible: true });
    this.endNode.set({ visible: true });
    this.canvas.renderAll();
  }
  
  // Function to hide control points
  _hideControlPoints() {
    this.startNode.set({ visible: false });
    this.endNode.set({ visible: false });
    this.canvas.renderAll();
  }
  
  // Ensure control points visibility based on line selection
  _checkControlPointVisibility() {
    console.log("this.path.selected",this.path )
    if (this.path.selected) {
      this._showControlPoints();
    } else {
      this._hideControlPoints();
    }
  }
  _updatePath() {
    // Remove old path
    this.canvas.remove(this.path);
  
    // Dynamically recalculate the elbow position based on start and end points
    const middleX = (this.startX + this.endX) / 2; // Calculate a mid-point for the elbow
    const middleY = (this.startY + this.endY) / 2;
  
    // Update the elbow position
    this.elbowX = middleX;  // You can adjust this logic based on your specific needs
    this.elbowY = middleY;  // You can adjust this logic based on your specific needs
  
    // Create updated path
    this.path = new fabric.Path(this._createPathString(this.startX, this.startY, this.elbowX, this.elbowY, this.endX, this.endY), {
      stroke: "black",
      strokeWidth: this.path.strokeWidth,
      fill: "transparent",
      selectable: true,
      evented: true,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      class: "line",
    });
  
    // Add updated path to canvas
    this.canvas.add(this.path);
    this.canvas.sendToBack(this.path);
  
   // Compute the direction vector
   const dx = this.endX - this.startX;
   const dy = this.endY - this.startY;
   const length = Math.sqrt(dx * dx + dy * dy);

   if (length === 0) return; // Avoid division by zero

   // Normalize the direction vector
   const offsetX = (dx / length) * (this.strokeWidth / 2 + 6);
   const offsetY = (dy / length) * (this.strokeWidth / 2 + 6);

 // Update control points
 this.startNode.set({
   left: this.startX - this.startNode.radius - offsetX,
   top: this.startY - this.startNode.radius - offsetY,
 });

 this.endNode.set({
   left: this.endX - this.endNode.radius + offsetX,
   top: this.endY - this.endNode.radius + offsetY,
 });

    // Ensure positions are updated correctly
    this.startNode.setCoords();
    // this.elbowNode.setCoords();
    this.endNode.setCoords();
  
    // Re-render canvas
    this.canvas.renderAll();
  }
  
}



export class CirclePath {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.startAngle = options.startAngle || 0;
    this.endAngle = options.endAngle || 360;
    this.radius = options.radius || 50;
    this.left = options.left || 0;
    this.top = options.top || 0;
    this.angleType = options.angleType || "arc"; // Default to 'arc'
    this.originX = options.originX;
    this.originY = options.originY;
    this._createCirclePath();

    // Attach instance to path for later use
    this.path.circlePathInstance = this;
  }

  _createCirclePath() {
    // Capture current transformations
    const transforms = this.path
      ? {
          scaleX: this.path.scaleX,
          scaleY: this.path.scaleY,
          angle: this.path.angle,
          skewX: this.path.skewX,
          skewY: this.path.skewY,
          left: this.path.left,
          top: this.path.top,
        }
      : {};

    if (this.path) {
      this.canvas.remove(this.path);
    }

    this.path = new fabric.Path(this._createPathArray(), {
      stroke: "black",
      strokeWidth: 2,
      fill: "transparent",
      selectable: true,
      evented: true,
      radius: this.radius,
      left: this.left,
      top: this.top,
      class: "circle",
      ...transforms, // Reapply the captured transformations
    });

    this.path.setStartAngle = (angle) => {
      this.setStartAngle(angle);
    };

    this.path.setEndAngle = (angle) => {
      this.setEndAngle(angle);
    };

    this.path.setRadius = (radius) => {
      this.setRadius(radius);
    };

    this.path.setAngleType = (type) => {
      this.setAngleType(type);
    };

    this.canvas.add(this.path);
    this.canvas.renderAll();
  }

  _createPathArray() {
    const centerX = this.left + this.radius;
    const centerY = this.top + this.radius;
    const startPoint = this._calculatePoint(this.startAngle);
    const endPoint = this._calculatePoint(this.endAngle);
    const largeArcFlag = this.endAngle - this.startAngle >= 180 ? "1" : "0";
    const sweepFlag = this.endAngle - this.startAngle >= 0 ? "1" : "0";

     if (
    this.startAngle === this.endAngle ||
    Math.abs(this.endAngle - this.startAngle) === 360
  ) {
    const kappa = 0.5522847498307936; // magic constant for circle approximation with Beziers
    const r = this.radius;

    return [
      ["M", centerX, centerY - r],
      ["C", centerX + kappa * r, centerY - r, centerX + r, centerY - kappa * r, centerX + r, centerY],
      ["C", centerX + r, centerY + kappa * r, centerX + kappa * r, centerY + r, centerX, centerY + r],
      ["C", centerX - kappa * r, centerY + r, centerX - r, centerY + kappa * r, centerX - r, centerY],
      ["C", centerX - r, centerY - kappa * r, centerX - kappa * r, centerY - r, centerX, centerY - r],
      ["Z"]
    ];
  }

    let pathArray;
    if (this.angleType === "chord") {
      // Chord segment
      if (Math.abs(this.endAngle - this.startAngle) === 360) {
        pathArray = [
          ["M", startPoint.x, startPoint.y],
          [
            "A",
            this.radius,
            this.radius,
            0,
            largeArcFlag,
            sweepFlag,
            endPoint.x,
            endPoint.y,
          ],
          ["Z"],
        ];
      } else {
        pathArray = [
          ["M", startPoint.x, startPoint.y],
          [
            "A",
            this.radius,
            this.radius,
            0,
            largeArcFlag,
            sweepFlag,
            endPoint.x,
            endPoint.y,
          ],
          ["L", endPoint.x, endPoint.y],
          ["Z"],
        ];
      }
    } else if (
      this.startAngle === this.endAngle ||
      Math.abs(this.endAngle - this.startAngle) === 360
    ) {
      // Full circle
      pathArray = [
        ["M", centerX, centerY - this.radius],
        [
          "A",
          this.radius,
          this.radius,
          0,
          1,
          1,
          centerX,
          centerY + this.radius,
        ],
        [
          "A",
          this.radius,
          this.radius,
          0,
          1,
          1,
          centerX,
          centerY - this.radius,
        ],
      ];
    } else {
      // Arc segment
      pathArray = [
        ["M", startPoint.x, startPoint.y],
        [
          "A",
          this.radius,
          this.radius,
          0,
          largeArcFlag,
          sweepFlag,
          endPoint.x,
          endPoint.y,
        ],
        ["L", centerX, centerY],
        ["Z"],
      ];
    }

    return pathArray;
  }

  _calculatePoint(angle) {
    const rad = fabric.util.degreesToRadians(angle);
    return {
      x: this.left + this.radius + this.radius * Math.cos(rad),
      y: this.top + this.radius + this.radius * Math.sin(rad),
    };
  }

  _updatePath() {
    this._createCirclePath();
  }

  setRadius(radius) {
    this.radius = radius;
    this._updatePath();
  }

  setStartAngle(angle) {
    this.startAngle = angle;
    this._updatePath();
  }

  setEndAngle(angle) {
    this.endAngle = angle;
    this._updatePath();
  }

  setAngleType(type) {
    this.angleType = type;
    this._updatePath();
  }
}

export class SnippedRectangle {
  constructor(canvas, options) {
    this.canvas = canvas;

    // Create a regular rectangle
    this.rectangle = new fabric.Rect({
      left: options.left,
      top: options.top,
      width: options.width,
      height: options.height,
      fill: options.fill || "transparent",
      stroke: options.stroke || "black",
      strokeWidth: options.strokeWidth || 1,
      selectable: options.selectable !== undefined ? options.selectable : true,
      evented: options.evented !== undefined ? options.evented : true,
      originX: "left",
      originY: "top",
    });

    // Create a clipping path to snip the top-right corner
    const clipPath = new fabric.Path(
      `M 0 0 L ${options.width - options.cornerRadius} 0 L ${options.width} ${
        options.cornerRadius
      } L ${options.width} ${options.height} L 0 ${options.height} Z`,
      {
        top: options.top,
        left: options.left,
        fill: "transparent",
        stroke: "transparent",
      }
    );

    this.rectangle.set({
      clipPath: clipPath,
    });

    // Add objects to the canvas
    this.canvas.add(this.rectangle);

    // Log object to verify creation and addition
    console.log("Rectangle added to canvas:", this.rectangle);
  }
}

export class RoundedPolygon {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.cornerRadius = options.cornerRadius || 10;
    this.points = options.points || [];

    // Create the path with rounded corners
    this.path = new fabric.Path(this.createPathData(), {
      left: options.left,
      top: options.top,
      fill: options.fill || "transparent",
      stroke: options.stroke || "black",
      strokeWidth: options.strokeWidth || 1,
      selectable: options.selectable !== undefined ? options.selectable : true,
      evented: options.evented !== undefined ? options.evented : true,
    });

    // Add the path to the canvas
    this.canvas.add(this.path);
    this.canvas.renderAll(); // Ensure the canvas is rendered
  }

  // Method to create the path data for the polygon with rounded corners
  createPathData() {
    const { points, cornerRadius } = this;
    if (points.length < 3) return ""; // Not enough points to create a polygon

    let pathData = "";

    // Helper function to create rounded corner path data
    const createRoundedCornerPath = (p1, p2, p3, radius) => {
      const dx1 = p1.x - p2.x;
      const dy1 = p1.y - p2.y;
      const dx2 = p3.x - p2.x;
      const dy2 = p3.y - p2.y;

      const angle = (Math.atan2(dy1, dx1) - Math.atan2(dy2, dx2)) / 2;
      const tan = Math.abs(Math.tan(angle));
      const segment = radius / tan;

      const length1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
      const length2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
      const length = Math.min(length1, length2);

      if (segment > length) {
        radius = length * tan;
      }

      const getProportionPoint = (point, segment, length, dx, dy) => {
        const factor = segment / length;
        return {
          x: point.x - dx * factor,
          y: point.y - dy * factor,
        };
      };

      const p1Cross = getProportionPoint(p2, segment, length1, dx1, dy1);
      const p2Cross = getProportionPoint(p2, segment, length2, dx2, dy2);

      const circleCenter = {
        x: p2.x * 2 - p1Cross.x - p2Cross.x,
        y: p2.y * 2 - p1Cross.y - p2Cross.y,
      };

      const dx = p2.x * 2 - p1Cross.x - p2Cross.x;
      const dy = p2.y * 2 - p1Cross.y - p2Cross.y;
      const d = Math.sqrt(dx * dx + dy * dy);

      const circlePoint = getProportionPoint(p2, d, radius, dx, dy);

      const startAngle = Math.atan2(
        p1Cross.y - circlePoint.y,
        p1Cross.x - circlePoint.x
      );
      const endAngle = Math.atan2(
        p2Cross.y - circlePoint.y,
        p2Cross.x - circlePoint.x
      );
      const sweepAngle = endAngle - startAngle;

      return `M${p1Cross.x},${p1Cross.y} A${radius},${radius} 0 0,1 ${p2Cross.x},${p2Cross.y} L${p2.x},${p2.y}`;
    };

    // Loop through the points to generate the path
    for (let i = 0; i < points.length; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % points.length];
      const p3 = points[(i + 2) % points.length];

      if (i === 0) {
        pathData += `M${p1.x},${p1.y}`;
      }

      pathData += createRoundedCornerPath(p1, p2, p3, cornerRadius);
    }

    pathData += "Z"; // Close the path

    return pathData;
  }

  // Method to update the corner radius
  updateCornerRadius(newRadius) {
    this.cornerRadius = newRadius;
    this.path.set({ path: this.createPathData() });
    this.canvas.renderAll();
  }
}
